import classNames from "classnames";
import { CSSProperties, FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  className?: string;
  progress: number;
};

const Progress: FC<Props> = ({ progress, className }) => {
  const progressStyle = {
    "--progress": `${progress}%`,
  } as CSSProperties;

  return (
    <div
      data-progress
      className={classNames(styles.progress, className)}
      style={progressStyle}
      aria-label="Прогресс"
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
    />
  );
};

export default Progress;
